const AUGUST_CLOSURE_YEAR = 2026;
const AUGUST_CLOSURE_MONTH = 7;
const AUGUST_CLOSURE_FIRST_DAY = 4;
const AUGUST_CLOSURE_LAST_DAY = 16;

export const isEventDateUnavailable = (date: Date) =>
  date.getFullYear() === AUGUST_CLOSURE_YEAR &&
  date.getMonth() === AUGUST_CLOSURE_MONTH &&
  date.getDate() >= AUGUST_CLOSURE_FIRST_DAY &&
  date.getDate() <= AUGUST_CLOSURE_LAST_DAY;

type EventDateRange = {
  from?: Date;
  to?: Date;
};

export const doesEventDateRangeIncludeUnavailableDate = ({ from, to }: EventDateRange) => {
  if (!from) return false;

  const fromDay = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const rangeEnd = to ?? from;
  const toDay = new Date(rangeEnd.getFullYear(), rangeEnd.getMonth(), rangeEnd.getDate());
  const start = fromDay <= toDay ? fromDay : toDay;
  const end = fromDay <= toDay ? toDay : fromDay;
  const closureStart = new Date(AUGUST_CLOSURE_YEAR, AUGUST_CLOSURE_MONTH, AUGUST_CLOSURE_FIRST_DAY);
  const closureEnd = new Date(AUGUST_CLOSURE_YEAR, AUGUST_CLOSURE_MONTH, AUGUST_CLOSURE_LAST_DAY);

  return start <= closureEnd && end >= closureStart;
};
